import type {
  StoreSupplyTimelineParams,
  SupplyTimelineParams,
  SupplyTimelineResponse,
} from '@gozoki/api-types'
import { keepPreviousData, type UseQueryResult, useQuery } from '@tanstack/react-query'
import { fetchStoreSupplyTimeline, fetchSupplyTimeline } from '../queries/supply.queries'

export const useSupplyTimeline = (
  selection: SupplyTimelineParams,
  enabled = true,
): UseQueryResult<SupplyTimelineResponse, unknown> => {
  const normalizedScope =
    selection.targetId !== undefined ? (selection.scope ?? 'category') : selection.scope

  return useQuery({
    enabled,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => fetchSupplyTimeline(selection, signal),
    queryKey: [
      'supply-timeline',
      selection.storeId,
      selection.days,
      normalizedScope,
      selection.targetId,
    ],
    refetchInterval: 5 * 60_000,
  })
}

// store-app : timeline de la boutique connectée (guard `store`). Pas de storeId (dérivé du token).
export const useStoreSupplyTimeline = (
  selection: StoreSupplyTimelineParams,
  enabled = true,
): UseQueryResult<SupplyTimelineResponse, unknown> => {
  const normalizedScope =
    selection.targetId !== undefined ? (selection.scope ?? 'category') : selection.scope

  return useQuery({
    enabled,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => fetchStoreSupplyTimeline(selection, signal),
    queryKey: ['store-supply-timeline', selection.days, normalizedScope, selection.targetId],
    refetchInterval: 5 * 60_000,
  })
}
